export default __webpack_public_path__ + "static/rahul-6614ad3242ed7037a84cc14fcc7612ec.png";